/* global lightGallery */
/* global lgAutoplay */
/* global lgThumbnail */
/* global lgVideo */

class LightGallery {
  constructor(options = {}) {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="LightGallery"]'),
      ...options
    };
  }

  init() {
    const { moduleList } = this.config;
    moduleList().forEach(listItem => {
      lightGallery(listItem, {
        plugins: [lgAutoplay, lgThumbnail, lgVideo],
        download: false,
        hideControlOnEnd: true,
        loop: false,
        selector: '.js-lightgallery-item',
        thumbHeight: '40px',
        thumbWidth: 60,
        autoplayControls: false,
        licenseKey: 'AED02E49-B3CE46DE-8341A8D4-BE50CBBF',
        mobileSettings: {
          showCloseIcon: true
        }
      });
    });
  }
}

export default LightGallery;
